<template>
  <div class="ui-bottom-btns-wrapper" :class="{ more: showMoreBtn }">
    <div class="btn btn-message" @click="handleLeaveMessage" :style="{ background: btnColorMsg }">
      <i class="icon icon-write"></i>
      <span class="btn-text">我要留言</span>
    </div>
    <div class="btn btn-poster" @click="handleSharePoster" :style="{ background: btnColorShare }">
      <i class="icon icon-share"></i>
      <span class="btn-text">分享海报</span>
    </div>
    <template v-if="showMoreBtn">
      <div class="btn btn-poster" @click="handleJumpLink('https://t.southcn.com/ep14X')" :style="{ background: btnColorShare }">
        <span class="btn-text">云游展馆</span>
      </div>
      <!--      <div class="btn btn-poster" @click="handleJumpLink('https://t.southcn.com/1ZJfsd')" :style="{ background: btnColorShare }">-->
      <!--        <span class="btn-text">红色地图</span>-->
      <!--      </div>-->
    </template>
  </div>
</template>

<script>
import nfpluslogin from "@/mixins/nfplusLogin"
import { buryingPoint } from "@/server/interfaces"
import { mapGetters } from "vuex"

export default {
  name: "uiBottomBtns",
  props: {
    showLeaveMessageBtn: {
      type: Boolean,
      default: true
    },
    showSharePosterBtn: {
      type: Boolean,
      default: true
    }
  },
  mixins: [nfpluslogin],
  methods: {
    async handleLeaveMessage() {
      this._buryingPointClickLeaveMessage()
      const hasUserInfo = await this.nfplusLogin()
      hasUserInfo && this.$emit("leaveMessage")
    },
    async handleSharePoster() {
      this._buryingPointClickSharePoster()
      const hasUserInfo = await this.nfplusLogin()
      hasUserInfo && this.$emit("sharePoster")
    },
    handleJumpLink(link) {
      window.open(link)
    },
    _buryingPointClickSharePoster() {
      buryingPoint({
        params: {
          action: 6
        }
      })
    },
    _buryingPointClickLeaveMessage() {
      buryingPoint({
        params: {
          action: 10
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      btnColorMsg: "activityInfo/btnColorMsg",
      btnColorShare: "activityInfo/btnColorShare",
      activityId: "activityInfo/activityId"
    }),
    showMoreBtn() {
      return +this.activityId === 200
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-bottom-btns-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0.3rem;
  padding: 0 0.1rem;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
  left: 0;
  z-index: 3;
  width: 100%;
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  .btn {
    width: 3rem;
    height: 0.88rem;
    text-align: center;
    line-height: 0.88rem;
    border: none;
    background: transparent;
    outline: none;
    margin-right: 0.4rem;
    border-radius: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &:active {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      height: 0.4rem;
      width: 0.4rem;
      margin-right: 0.06rem;
      &.icon-write {
        background: url("../../assets/images/icon_write.png") no-repeat center;
        background-size: 100%;
      }
      &.icon-share {
        background: url("../../assets/images/icon_share.png") no-repeat center;
        background-size: 100%;
      }
    }
  }
}

.more {
  .btn {
    margin-right: 0.15rem;
  }
}

.ui-bottom-btns-wrapper.pc {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 30px;
  bottom: 56px;
  .btn {
    width: 300px;
    height: 56px;
    line-height: 56px;
    border-radius: 50px;
    margin-right: 40px;
    &:last-child {
      margin-right: 0;
    }
    .icon {
      height: 26px;
      width: 26px;
      margin-right: 16px;
    }
  }
}
</style>
